import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byteInGb',
  standalone: true,
})
export class ByteInGbPipe implements PipeTransform {

  public transform(value: number): string {
    if (value == null) {
      return 'Unknown';
    }

    const gb = value / (1024 * 1024 * 1024);

    if (gb < 0.01) {
      return `${value} bytes`;
    }

    return `${gb.toFixed(2)} GB`;
  }

}


